import { render } from "./PendingPayment.vue?vue&type=template&id=08997d74&scoped=true"
import script from "./PendingPayment.vue?vue&type=script&lang=js"
export * from "./PendingPayment.vue?vue&type=script&lang=js"

import "./PendingPayment.vue?vue&type=style&index=0&id=08997d74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08997d74"]])

export default __exports__